import { expandOperatorIds } from '@entities/operator';

export default (product, filter) => (filter && filter.length ? !!~expandOperatorIds(filter).indexOf(product.get('product')?.get('operator')?.id) : true);
